// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V2_A","newExpiryDate":"styles_newExpiryDate__qlxe2","footer":"styles_footer__3ztnh"};